import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from "../context/AuthContext";
import { UserRound, ShoppingBag } from 'lucide-react';
import {
  setOpenCart,
  selectTotalQTY
} from '../CartSlice';



const ShopWrapper = () => {
  const [products, setProducts] = useState([]);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupVisibleSize, setPopupVisibleSize] = useState(false); // State for popup visibility
  const dispatch = useDispatch();
  const totalQTY = useSelector(selectTotalQTY);
  const [, setRates] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const { token, logout } = useAuth(); // Get token and logout function
  const dropdownRef = useRef(null);
  const isLoggedIn = !!token;

  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  // WORKS
  const fetchExchangeRates = async () => {
    try {
      const response = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
      const data = await response.json();
      setRates(data.rates);  // Store exchange rates
    } catch (error) {
      console.error('Error fetching exchange rates:', error);
    }
  };

  const onCartToggle = () => {
    dispatch(setOpenCart({ cartState: true }));
  };

  const fetchProducts = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/product`);
      // const response = await fetch(`${process.env.REACT_APP_API_URL}/product`);
      // console.log('Response status:', response.status)
      if (response.ok) {
        const data = await response.json();
        setProducts(data);
      } else {
        console.error('Error fetching products');
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchExchangeRates();
  }, []);


  return (
    <>
      <div className="xl:p-20 lg:p-20 md:p-10 p-5 ">

        {products.length === 0 ? (
          <p className="flex justify-center items-center h-[400px] capitalize text-lg text-[#252525]">There are no products currently available.</p>
        ) : (
            <>
            <div className="flex items-center justify-between py-4 my-2 xl:mx-[100px] lg:mx-[100px] md:mx-[20px] mx-[4px] gap-2 mb-8">
              {/* Currency Selector */}
              <div className="flex items-center justify-between w-full">
                {/* Currency selector */}
                <div className="flex items-center">
                  <p className='xl:text-3xl lg:text-2xl md:text-2xl text-2xl uppercase text-black font-semibold tracking-[0.1em]'>
                    sope
                  </p>
                  {/* <label className="mr-2 text-white">Currency:</label>
                  <select
                    value={currency}
                    onChange={(e) => handleCurrencyChange(e.target.value)}
                    className="bg-[#373333] border border-[#373333] text-white p-2 cursor-pointer"
                  >
                    <option value="USD">USD ($)</option>
                    <option value="NGN">Naira (₦)</option>
                    <option value="EUR">Euro (€)</option>
                    <option value="GBP">Pound (£)</option>
                  </select> */}
                </div>

                {/* User and Cart container */}
                <div className="flex items-center gap-4">
                  {/* User dropdown */}
                  <div className="relative" ref={dropdownRef}>
                    <div onClick={() => setIsOpen(!isOpen)} className="cursor-pointer">
                      <UserRound />
                    </div>
                    {isOpen && (
                      <div
                        className="absolute right-0 mt-2 w-48 bg-white border border-[#fff] shadow-lg"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {isLoggedIn ? (
                          <ul className="py-2 text-sm text-[#252525]">
                            <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                              <a href="/dashboard">
                                Profile
                              </a>
                            </li>
                            {/*<li className="px-4 py-2 hover:bg-[#252525] cursor-pointer">Settings</li>*/}
                            <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer" onClick={logout}>
                              Logout
                            </li>
                          </ul>
                        ) : (
                          <ul className="py-2 text-sm text-[#252525]">
                            <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => { 
                              setIsOpen(false); 
                              navigate("/login"); 
                            }}>
                              Login
                            </li>
                            <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => { 
                              setIsOpen(false); 
                              navigate("/register"); 
                            }}>
                              Register
                            </li>
                          </ul>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Shopping bag */}
                  <div className="relative cursor-pointer" onClick={onCartToggle}>
                    <ShoppingBag />
                    <div className="absolute -top-1 -right-1 bg-[#373333] rounded-full w-5 h-5 flex items-center justify-center">
                      <span className="text-white text-xs">{totalQTY}</span>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            

          <div
            className="grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2
            xl:mx-[100px] lg:mx-[100px] md:mx-[50px] sm:mx-[20px] mx-[10px]"
          >
            {products.map((product) => (
              <div key={product.id} className="p-2 cursor-pointer">
                <Link to={`/prints/${product.slug}`}>
                  <div className="relative w-full aspect-square overflow-hidden mb-2 rounded-[20px] border-white group">
                    {/* First image (default) */}
                    <img
                      src={product.images[0]}
                      alt={product.name}
                      className="w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-0"
                    />
                    
                    {/* Second image (on hover) */}
                    {product.images[1] && (
                      <img
                        src={product.images[1]}
                        alt={`${product.name} - alternate`}
                        className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                      />
                    )}
                  </div>
                </Link>

                <div className=" sm:p-2">
                  {/*<div className="border-b border-[#b7a78b] py-2">*/}
                  <div className="">
                    <p className="text-[#252525] text-left text-[15px] mb-2 capitalize">
                      {product.name}
                    </p>
                    <p className="text-[#252525] text-left text-[15px] mb-2 capitalize">
                      ${product.amount}
                    </p>
                  </div>
                  <div className="flex flex-wrap items-center justify-between gap-3">
                    {/*<div className="flex-1 text-left">
                      <p className="text-white font-semibold text-lg sm:text-xl">
                        {currency === "USD"
                          ? "$"
                          : currency === "NGN"
                          ? "\u20A6"
                          : currency === "EUR"
                          ? "€"
                          : "£"}
                        {convertPrice(
                          selectedProductDetails[product.id]?.price || product.amount,
                          "USD",
                          currency,
                          rates
                        )}
                      </p>
                    </div>
                    <div>
                      <select
                        className="bg-transparent border border-[#b7a78b] text-white py-2 px-4 w-[90px] sm:w-[100px] cursor-pointer"
                        value={selectedProductDetails[product.id]?.size || ""}
                        onChange={(e) => handleSizeChange(e, product)}
                      >
                        <option value="" disabled>
                          Size
                        </option>
                        {product.sizes.map((size, index) => (
                          <option key={index} value={size.size} className="text-black">
                            {size.size}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="flex items-center justify-center gap-2 flex-1">
                      <button
                        onClick={() => updateCart(product, -1)}
                        className="bg-[#b7a78b] text-white w-6 h-6 flex items-center justify-center active:scale-90"
                      >
                        -
                      </button>
                      <div className="bg-[#b7a78b] text-white font-medium w-7 h-6 flex items-center justify-center">
                        {getCartQuantity(product.id)}
                      </div>
                      <button
                        onClick={() => updateCart(product, 1)}
                        className="bg-[#b7a78b] text-white w-6 h-6 flex items-center justify-center active:scale-90"
                      >
                        +
                      </button>
                    </div>*/}
                    {/*<div className="flex-1 text-right">
                      <button
                        type="button"
                        className="w-full text-white bg-transparent transition-all duration-300 border border-[#b7a78b] text-[12px] 
                          font-medium py-2 hover:bg-[#b7a78b] hover:text-white hover:scale-105 hover:shadow-lg uppercase tracking-[0.2em]"
                        onClick={() =>
                          onAddToCart({
                            id: product.id,
                            title: product.name,
                            text: product.summary,
                            img: product.cover,
                            price: product.amount,
                            quantity: getCartQuantity(product.id),
                            currency: currency,
                          })
                        }
                      >
                        Add to Cart
                      </button>
                    </div>*/}
                  </div>
                </div>
              </div>
            ))}
          </div>

          </>
        )}

        {/* Popup Component */}
        {popupVisible && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-4 shadow-lg">
              <p className="font-semibold">Please increase the product quantity to at least 1!</p>
              <button 
                className="mt-4 px-4 py-2 bg-[#b7a78b] text-white"
                onClick={() => setPopupVisible(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}



        {popupVisibleSize && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-4 shadow-lg">
              <p className="font-semibold">Please select a size before adding to the cart!</p>
              <button 
                className="mt-4 px-4 py-2 bg-[#b7a78b] text-white"
                onClick={() => setPopupVisibleSize(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default ShopWrapper;